// extracted by mini-css-extract-plugin
module.exports = {"richTextBlock":"RichText_richTextBlock__ew8IZ","paragraph":"RichText_paragraph__SRuFC"};